<div class="content-container">
    <div class="fixed-header">
        <app-second-header [headline]="'Spenden'">
            <span class="total" id="total">{{ total }}</span>
            <button mat-flat-button color="primary" routerLink="/manual-assign">
                <mat-icon>add</mat-icon> Neue Spende
            </button>
        </app-second-header>

        <div fxLayout="row" fxLayoutGap="10px">
            <app-action-card
                [title]="'Kontoauszüge abrufen'"
                [caption]="''"
                [type]="actionCardType.IMPORT_DONATIONS"
                (getData)="skip = 0; getData()"
            ></app-action-card>
            <app-action-card
                [title]="'Spenden zuweisen'"
                [caption]="'Jetzt zuweisen'"
                [type]="actionCardType.ASSIGN"
            ></app-action-card>
            <app-action-card
                [title]="'Einzelspenden bescheinigen'"
                [caption]="'Bescheinigungen ausstellen'"
                [type]="actionCardType.PRINT_SINGLE"
            ></app-action-card>
            <app-action-card
                [title]="'Dauerspenden bescheinigen'"
                [caption]="'Bescheinigungen ausstellen'"
                [type]="actionCardType.PRINT_PERMANENT"
            ></app-action-card>
        </div>

        <hr />

        <app-ao-filter-header-list
            *ngIf="headerSettings"
            [settings]="headerSettings"
            [(filter)]="filter"
            (filterChange)="onFilterChange()"
            [(skip)]="skip"
            [(limit)]="limit"
            [(sort)]="sort"
            (sortChange)="skip = 0; getData()"
            (hiddenFiltersChange)="hiddenFilters = $event"
            [showSelect]="false"
            [showFilterSettings]="true"
            [pageType]="filterPageType.DONATIONS"
        ></app-ao-filter-header-list>
    </div>

    <div
        infiniteScroll
        [scrollWindow]="true"
        (scrolled)="onScroll()"
        [infiniteScrollDistance]="2"
        [infiniteScrollThrottle]="10"
    >
        <div *ngFor="let donation of $donationsObservable | async">
            <app-donation-row
                (delete)="onDelete(donation._id)"
                [donation]="donation"
                [hiddenFilters]="hiddenFilters"
                [spans]="spans"
                [visibleSpans]="visibleSpans"
            ></app-donation-row>
        </div>

        <div *ngIf="activeRequest" class="spinner">
            <mat-spinner></mat-spinner>
        </div>
    </div>
</div>
